import React, { useState, useEffect } from 'react';
import '../css/Login.css';
import CustomButton from '../components/CustomButton';
import { useHistory } from 'react-router-dom';
import { IsLoggedIn, logUserIn, getProfile } from '../api/Firebase';
import { userToken, userProfile, systemMessage } from '../State';
import { useRecoilState } from 'recoil';


const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const [user, setUser] = useRecoilState(userToken);
    const [profile, setProfile] = useRecoilState(userProfile);
    const [sysMsg, setSysMsg] = useRecoilState(systemMessage);

    const login = () => {
        logUserIn(username, password, (error) => {
            setError('Error: ' + error.code + ' :: ' + error.message);
            setSysMsg("Login Failed");
        })
    }

    useEffect(() => {
        IsLoggedIn(u => {
            setSysMsg('Login successful');
            // console.log("logged In user: ", u);
            setUser(u);
            getProfile(u.uid, (data) => {
                setProfile(data);
                history.push("/home");
            },
                (msg) => {
                    //console.log(msg);
                }
            )

        }, () => {
            //console.log("no logged In user");
            setUser('none');
            setProfile(null);
            history.push("/");
            setSysMsg('Logged out');
        })
    }, []);

    const updateUsername = e => {
        setUsername(e.target.value);
        setError('');
    }

    const updatePassword = e => {
        setPassword(e.target.value);
        setError('');
    }

    const signUp = () => {
        history.push('/SignUp');
    }

    let history = useHistory();

    let linkStyle = {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        justifyContent: 'space-evenly',
        alignItems: 'center',
    }

    return (
        <div className="login-container">
            <img src="images/logo.png" />

            <div className="login-card">
                <div className="login-card-header">
                    <h3>eDocket</h3>
                </div>

                <div className="login-card-main">
                    <label htmlFor="username">Email</label>
                    <input id="username" type="text" placeholder="email@address.com" value={username} onChange={updateUsername} />
                    <label htmlFor="password" >Password</label>
                    <input id="password" type="password" placeholder="Password" value={password} onChange={updatePassword} />
                    <CustomButton className="login-button" width="50%" onClick={login}>Login</CustomButton>
                </div>

                <div className="login-card-footer">
                    <div style={linkStyle}>
                        <p className="login-link" onClick={signUp}>Sign up</p>
                        <p className="login-link" onClick={() => history.push('/forgot')}>Forgot Password?</p>
                    </div>

                    <p className="login-error">{error}</p>
                </div>
            </div>
        </div>
    );
}

export default Login;